module.exports = __webpack_public_path__ + "files/SPIADI2019 - Réa Inf ADI.02dfed67acd244259b8953a779f9ed7b.pdf";